module.exports = __webpack_public_path__ + "img/Meeting.3da2e969.svg";